export default __webpack_public_path__ + "static/media/brand_toke.c3982823.svg";